import { useParams } from "react-router-dom";

import { ProtectedModuleReader } from "@/components/modules/ProtectedModuleReader";


export default function ModuleReaderPage() {
  const { moduleCode = "" } = useParams();
  return <ProtectedModuleReader moduleCode={moduleCode} />;
}
